module.exports = __webpack_public_path__ + "img/Angeberinnen.4692669a.svg";